import { useMemo } from "react";
import { useUser } from "@/hooks/useUser";
import { RebuildAvatar } from "@/components/RebuildAvatar";

type PersonBadgeProps = {
  id: string | undefined;
  emptyLabel?: string;
  unresolvedLabel?: string;
};

export const PersonBadge = ({ id, emptyLabel = "Unassigned", unresolvedLabel = "Unassigned" }: PersonBadgeProps) => {
  const { users } = useUser();

  const userMap = useMemo(() => new Map(users?.map((user) => [user.lassoUserId, user])), [users]);

  const userObj = id ? userMap.get(id) : undefined;

  const name = userObj ? `${userObj.firstName} ${userObj.lastName}` : id ? unresolvedLabel : emptyLabel;
  const initials = userObj ? `${userObj.firstName?.[0] ?? ""}${userObj.lastName?.[0] ?? ""}`.toUpperCase() || "U" : "?";

  return (
    <div className="flex items-center gap-2">
      <RebuildAvatar photo={userObj?.photoURL} initials={initials} />
      {name}
    </div>
  );
};
